var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { TypeTicket } from '../../Detail/DetailRoutes';
import { loading } from '../../../elements/Loading';
import PacketDetailView from './PacketDetailView';
import Afiliate from '../../Afiliates/Afiliate';
import { getIndexForMapeo } from '../../TempSale/TempSalePacket';
import { checkDisabledDay } from '../../../helpers/Utils';
import { PaymentMethod } from '../../../Models/TicketPayment';
let PacketDetail = class PacketDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sale: [],
            visibleExtras: false
        };
        this.handleKeyMinus = (item) => {
            this.props.store.tempTicketStore.tempSalePacket.setMinus(item);
        };
        this.handleKeyPlus = (item) => {
            // this.handleFecha()
            // console.log('handleKeyPlus - item: ', item)
            this.props.store.tempTicketStore.tempSalePacket.setPlus(item);
        };
        this.quantity = (item) => {
            return this.props.store.tempTicketStore.tempSalePacket.getQuantity(item);
        };
        this.lineTotal = (item) => {
            return this.props.store.tempTicketStore.tempSalePacket.getLineTotal(item);
        };
        this.handleCheckOut = () => __awaiter(this, void 0, void 0, function* () {
            const tempTicketStore = this.props.store.tempTicketStore;
            tempTicketStore.createSale().then(() => {
                this.props.store.UI.newWarning('paquete generado correctamente');
                tempTicketStore.tempSalePacket.reset();
                this.prepara(this.props);
            })
                .catch(reason => {
                console.log('Se ha producido un error - reason: ', reason);
            });
        });
        this.handleInputMethod = (event, ref) => {
            const name = ref.current.name;
            console.log('name: ', name);
            if (event.currentTarget.value === '') {
                return;
            }
            const numero = Number(event.currentTarget.value);
            console.log('numero: ', numero);
            if (Number.isNaN(numero)) {
                return this.props.store.UI.newWarning('Valor introducido no válido');
            }
            switch (name) {
                case PaymentMethod.Due:
                    this.props.store.tempTicketStore.tempSalePacket.setInputDefer(numero);
                    break;
                case PaymentMethod.Card:
                    this.props.store.tempTicketStore.tempSalePacket.setInputCard(numero);
                    break;
                case PaymentMethod.Credit:
                    this.props.store.tempTicketStore.tempSalePacket.setInputCredit(numero);
                    break;
                case PaymentMethod.Transfer:
                    this.props.store.tempTicketStore.tempSalePacket.setInputTransfer(numero);
                    break;
                case PaymentMethod.Other:
                    this.props.store.tempTicketStore.tempSalePacket.setInputOther(numero);
                    break;
                default:
                    this.props.store.UI.newWarning('Error procesando métodos de pago');
            }
        };
        this.handleInputCard = event => {
            console.log('value: ', event.currentTarget.value);
            const numero = Number(event.currentTarget.value || 0);
            console.log('handleInputCard - numero: ', numero);
            if (!Number.isNaN(numero)) {
                this.props.store.tempTicketStore.tempSalePacket.setInputCard(numero);
            }
            else {
                this.props.store.UI.newWarning('Valor introducido no válido');
            }
        };
        this.handleInputCredit = event => {
            const numero = Number(event.currentTarget.value || 0);
            if (!Number.isNaN(numero)) {
                this.props.store.tempTicketStore.tempSalePacket.setInputCredit(numero);
            }
            else {
                this.props.store.UI.newWarning('Valor introducido no válido');
            }
        };
        this.handleInputTransfer = event => {
            const numero = Number(event.currentTarget.value || 0);
            console.log('handleInputTransfer - numero: ', numero);
            if (!Number.isNaN(numero)) {
                this.props.store.tempTicketStore.tempSalePacket.setInputTransfer(numero);
            }
            else {
                this.props.store.UI.newWarning('Valor introducido no válido');
            }
        };
        this.handleInputOther = event => {
            const numero = Number(event.currentTarget.value || 0);
            if (!Number.isNaN(numero)) {
                this.props.store.tempTicketStore.tempSalePacket.setInputOther(numero);
            }
            else {
                this.props.store.UI.newWarning('Valor introducido no válido');
            }
        };
        this.handleKeyMinusExtras = () => {
        };
        this.handleKeyPlusExtras = () => {
        };
        this.lineTotalExtras = (item) => {
            return 0;
        };
        this.quantityExtras = (item) => {
            return 0;
        };
        this.onChangeExtras = () => {
        };
        this.onChangeHours = (stretch, hour) => {
            // console.log('PacketDetail - onChangeHours - stretch: ', stretch)
            // console.log('PacketDetail - onChangeHours - hour: ', hour)
            this.props.store.tempTicketStore.tempSalePacket.setHourToStretch(stretch, hour);
            this.render();
        };
        this.datestringToDate = (date) => {
            // console.log('PacketsDetail - handleDate - date', date)
            const parts = date.split('/');
            const datebook = new Date(parts[2], parts[1] - 1, parts[0]);
            // console.log('PacketsDetail - handleDate - datebook: ', datebook)
            return datebook;
        };
        this.onChangeDate = (stretch, date) => {
            console.log('onChangeDate - stretch: ', stretch);
            console.log('onChangeDate - date: ', date);
            this.props.store.tempTicketStore.tempSalePacket.setDateToStretch(stretch, date); // this.datestringToDate(date))
        };
        this.handleCheckbox = (name, value) => {
            console.log('StretchesDetail - handleCheckbox - name: ', name);
            console.log('StretchesDetail - handleCheckbox - value: ', value);
            switch (name) {
                case 'printPrice':
                    this.props.store.tempTicketStore.tempSalePacket.setPrintPrice(value);
                    break;
                case 'valitedNow':
                    this.props.store.tempTicketStore.tempSalePacket.setValitedNow(value);
                    break;
                case 'boardingPass':
                    this.props.store.tempTicketStore.tempSalePacket.setBoardingPass(value);
                    break;
                default:
            }
        };
        this.prepara(props);
    }
    prepara(props) {
        const { operationLineId, packetId } = props.match.params;
        const packet = this.props.packet;
        console.log('PacketDetail - packet: ', packet);
        this.state.sale = packet.prices.filter(price => !price.passengerCategory.disabled_at).map((item) => {
            // console.log('item: ', item)
            if (this.operationLine) {
                item.tax = this.operationLine.tax;
            }
            if (packet.tax) {
                item.tax = packet.tax;
            }
            // console.log('item: ', item)
            return { order: item.passengerCategory.order, quantity: 0, price: Object.assign(Object.assign({}, item), { printPrice: packet.printPrice }) };
        })
            .sort((a, b) => {
            return a.order - b.order;
        });
        props.store.tempTicketStore.setTypeTicket(TypeTicket.Packet);
        props.store.tempTicketStore.tempSalePacket.setPacket(packet);
        props.store.tempTicketStore.tempSalePacket.setOperationLine(this.operationLine);
        props.store.tempTicketStore.tempSalePacket.setClientId(this.props.store.users.user.client_id);
        props.store.tempTicketStore.tempSalePacket.setCollaboratorName(this.props.store.users.user.client);
        // props.store!.tempTicketStore.tempSalePacket.setPacket(packet)
        this.noMostrarMensaje = false;
    }
    render() {
        const { packet } = this.props;
        const sale = packet.prices.filter(price => !price.passengerCategory.disabled_at).map((item) => {
            // console.log('item: ', item)
            if (this.operationLine) {
                item.tax = this.operationLine.tax;
            }
            if (packet.tax) {
                item.tax = packet.tax;
            }
            // console.log('item: ', item)
            return { order: item.passengerCategory.order, quantity: 0, stretchPrice: Object.assign(Object.assign({}, item), { printPrice: packet.printPrice }) };
        })
            .sort((a, b) => {
            return a.order - b.order;
        });
        const visibleExtras = false; // this.state.visibleExtras
        let height = visibleExtras ? 65 : 70;
        const limite = 8;
        let paddingBloque = 15;
        const cantidad = sale.length;
        if (cantidad > 4) {
            paddingBloque = visibleExtras ? 8 : 6;
            height = visibleExtras ? 60 : 65;
            if (cantidad > limite) {
                paddingBloque = visibleExtras ? 6 : 4;
                height = visibleExtras ? 55 : 60;
            }
        }
        const tempSalePacket = this.props.store.tempTicketStore.tempSalePacket;
        const busy = this.props.store.tempTicketStore.busy;
        const moneyName = tempSalePacket.money;
        const afiliateNull = new Afiliate({
            id: 0,
            name: ''
        });
        const afiliates = [afiliateNull, ...this.props.store.afiliatesStore.data];
        // controlo las fechas deshabilitadas
        const someDateDisabled = packet.stretches.reduce((previous, currentStretch) => {
            const index = getIndexForMapeo(currentStretch);
            const dateSelected = this.props.store.tempTicketStore.tempSalePacket.datesSelected[index];
            const result = checkDisabledDay(currentStretch.horasIda, currentStretch.disabledDays, dateSelected);
            return previous || result;
        }, false);
        const busyNotSend = this.props.store.cashDeskTicketStore.busy;
        const checkins = tempSalePacket.checkins;
        const { totalWithoutDiscount } = tempSalePacket;
        const hoursSelectedOk = tempSalePacket.hoursSelectedOk;
        const errorTotal = (tempSalePacket.totalCard + tempSalePacket.totalCredit + tempSalePacket.totalTransfer + tempSalePacket.totalOther) > tempSalePacket.total;
        const disableCheckout = (someDateDisabled || busy || busyNotSend || checkins === 0 || totalWithoutDiscount < tempSalePacket.totalDiscount || totalWithoutDiscount === 0 || errorTotal || !hoursSelectedOk);
        const valitedNow = tempSalePacket.valitedNow;
        const boardingPass = tempSalePacket.boardingPass;
        const printPrice = tempSalePacket.printPrice;
        return (React.createElement(PacketDetailView, { packet: packet, tempSalePacket: tempSalePacket, sale: sale, height: height, paddingBloque: paddingBloque, busy: busy, moneyName: moneyName, quantity: this.quantity, lineTotal: this.lineTotal, handleKeyMinus: this.handleKeyMinus, handleKeyPlus: this.handleKeyPlus, handleInputPassenger: (input, item) => { }, showAfiliates: false, afiliates: afiliates, handleAfiliate: () => { }, showDiscountReason: false, discountReason: [], handleDiscountReason: () => { }, disableCheckout: disableCheckout, handleCheckOut: this.handleCheckOut, handleCheckbox: this.handleCheckbox, errorTotal: errorTotal, enablePaymentCredit: false, onHandleInputMethod: this.handleInputMethod, lineTotalExtras: this.lineTotalExtras, quantityExtras: this.quantityExtras, handleKeyMinusExtras: this.handleKeyMinus, handleKeyPlusExtras: this.handleKeyPlusExtras, onChangeExtras: this.onChangeExtras, onChangeHours: this.onChangeHours, onChangeDate: this.onChangeDate, valitedNow: valitedNow, disableValitedNow: false, boardingPass: boardingPass, disableboardingPass: false, printPrice: printPrice }));
    }
};
PacketDetail = __decorate([
    inject('store'),
    loading(props => {
        var _a, _b;
        if (!((_b = (_a = props.match) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.id) || !Number.isInteger(+props.match.params.id)) {
            return [];
        }
        return [
            props.store.packetsStore.read(props.match.params.id).then(packet => ({ packet }))
        ];
    }),
    observer
], PacketDetail);
export default PacketDetail;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/container/PacketDetail.tsx
// module id = 563
// module chunks = 0